import React from 'react';
import './SkillSearchBar.css';
import { useTranslation } from 'react-i18next';

interface SkillSearchBarProps {
  searchTerm?: string;
  setSearchTerm?: (value: string) => void;
  skillsEmpty?: boolean;
}

export const SkillSearchBar: React.FC<SkillSearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  skillsEmpty = false,
}) => {
  const { t } = useTranslation('library');

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="form-block-15 w-form div-block-483 topic-name">
      <div className='text-block-278'>Your skillset</div>
    <form
      className="form-10 pp"
      data-name={t('Email Form')}
      data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb836e79"
      data-wf-page-id="6596f9cde7a06c303cf07fbf"
      id="email-form"
      method="get"
      name="email-form"
    >
      <div className="div-block-410">
        <img
          alt=""
          className="image-164"
          loading="lazy"
          src="/images/magnifying-glass_1magnifying-glass.png"
        />
      </div>
      <input
        className="text-field-14 n_text w-input"
        data-name={t('Text 5')}
        id="text-5"
        maxLength={256}
        name="text-5"
        value={searchTerm}
        onChange={handleSearch}
        placeholder={t('Search')}
        required
        type="text"
        disabled={skillsEmpty}
      />
    </form>
    </div>
  );
};
